import React from 'react';

type ButtonRowProps = {
  children: React.ReactNode;
  compact?: boolean;
  className?: string;
};

const ButtonRow: React.FC<ButtonRowProps> = ({ children, compact = false, className }) => {
  const classes = ['btn-row', compact ? 'btn-row-compact' : '', className || '']
    .filter(Boolean)
    .join(' ');
  return <div className={classes}>{children}</div>;
};

export default ButtonRow;
